export default function NewsSection() {
  const news = [
    { tag: 'D-30', title: '겨울 안거 집중 수행 동참 안내', date: '2025.01.15' },
    { tag: '행사', title: '보광학교 졸업식 소식', date: '2025.01.10' },
    { tag: '공지', title: '선원 공양간 자원봉사 모집', date: '2025.01.05' }
  ];

  const videos = [
    {
      title: '대인 스님 법문: 참선의 핵심',
      views: '12,450',
      thumbnail: 'https://public.readdy.ai/ai/img_res/cda28ce85e1a3b7242e0e6dc24970c5f.jpg'
    },
    {
      title: '《금강경》 설하신 자리의 의미',
      views: '8,920',
      thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Buddhist%20scripture%20Diamond%20Sutra%20teaching%20scene%2C%20traditional%20Korean%20temple%20study%20room%20with%20wooden%20architecture%2C%20warm%20candlelight%20atmosphere%2C%20sacred%20Buddhist%20texts%2C%20peaceful%20learning%20environment%2C%20photorealistic%20spiritual%20scene&width=640&height=360&seq=video2&orientation=landscape'
    },
    {
      title: '법구경 하루 한 구절',
      views: '15,680',
      thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20Buddhist%20scripture%20calligraphy%20on%20traditional%20paper%2C%20peaceful%20meditation%20background%20with%20lotus%20flowers%2C%20warm%20golden%20lighting%2C%20spiritual%20wisdom%20text%2C%20Korean%20temple%20aesthetic%2C%20serene%20contemplative%20atmosphere%2C%20photorealistic%20artistic%20photography&width=640&height=360&seq=video3&orientation=landscape'
    }
  ];

  const gallery = [
    {
      title: '수행 대중 포토 앨범',
      count: '48장',
      image: 'https://readdy.ai/api/search-image?query=Group%20of%20Korean%20Buddhist%20monks%20and%20practitioners%20meditating%20together%20in%20traditional%20temple%20hall%2C%20peaceful%20community%20practice%20scene%2C%20warm%20natural%20lighting%2C%20spiritual%20harmony%2C%20traditional%20Korean%20temple%20interior%2C%20photorealistic%20documentary%20photography&width=400&height=300&seq=gallery1&orientation=landscape'
    },
    {
      title: '인도 성지 순례 스케치',
      count: '62장',
      image: 'https://readdy.ai/api/search-image?query=Buddhist%20pilgrims%20visiting%20sacred%20sites%20in%20Shravasti%20India%2C%20ancient%20Jetavana%20monastery%20ruins%2C%20peaceful%20spiritual%20journey%2C%20warm%20golden%20hour%20lighting%2C%20traditional%20pilgrimage%20scene%2C%20photorealistic%20travel%20photography&width=400&height=300&seq=gallery2&orientation=landscape'
    },
    {
      title: '참선 수행 후기',
      count: '35장',
      image: 'https://readdy.ai/api/search-image?query=Peaceful%20Korean%20Buddhist%20meditation%20retreat%20scene%2C%20practitioners%20in%20deep%20contemplation%2C%20traditional%20temple%20meditation%20hall%20with%20wooden%20floors%2C%20warm%20natural%20lighting%20through%20windows%2C%20serene%20spiritual%20atmosphere%2C%20photorealistic%20documentary%20style&width=400&height=300&seq=gallery3&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-amber-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 
          className="text-4xl font-bold text-center text-gray-900 mb-16"
          style={{ fontFamily: "'Noto Serif KR', serif" }}
        >
          소식 & 콘텐츠
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Latest News */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-amber-100">
            <div className="flex items-center justify-between mb-6">
              <h3 
                className="text-2xl font-bold text-gray-900"
                style={{ fontFamily: "'Noto Serif KR', serif" }}
              >
                최신 소식 & 공지
              </h3>
              <i className="ri-notification-3-line text-2xl text-amber-600"></i>
            </div>
            
            <div className="space-y-4">
              {news.map((item, index) => (
                <a
                  key={index}
                  href="#"
                  className="block p-4 rounded-lg hover:bg-amber-50 transition-colors border border-gray-100 cursor-pointer"
                >
                  <div className="flex items-start gap-3">
                    <span className="px-3 py-1 bg-amber-100 text-amber-800 text-xs font-semibold rounded-full whitespace-nowrap">
                      {item.tag}
                    </span>
                    <div className="flex-1">
                      <h4 className="font-semibold text-gray-900 mb-1 line-clamp-2">
                        {item.title}
                      </h4>
                      <p className="text-sm text-gray-500">{item.date}</p>
                    </div>
                  </div>
                </a>
              ))}
            </div>

            <a
              href="#"
              className="mt-6 w-full py-3 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg transition-colors flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
            >
              더보기
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          {/* Video Section */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-amber-100">
            <div className="flex items-center justify-between mb-6">
              <h3 
                className="text-2xl font-bold text-gray-900"
                style={{ fontFamily: "'Noto Serif KR', serif" }}
              >
                법문 영상
              </h3>
              <i className="ri-youtube-line text-2xl text-red-600"></i>
            </div>
            
            <div className="space-y-4">
              {videos.map((video, index) => (
                <a
                  key={index}
                  href="#"
                  className="block group cursor-pointer"
                >
                  <div className="relative rounded-lg overflow-hidden mb-2">
                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="w-full h-32 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                      <div className="w-12 h-12 bg-white/90 rounded-full flex items-center justify-center">
                        <i className="ri-play-fill text-2xl text-red-600"></i>
                      </div>
                    </div>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-1 line-clamp-2 group-hover:text-amber-700 transition-colors">
                    {video.title}
                  </h4>
                  <p className="text-sm text-gray-500">
                    <i className="ri-eye-line mr-1"></i>
                    {video.views} 조회
                  </p>
                </a>
              ))}
            </div>

            <a
              href="#"
              className="mt-6 w-full py-3 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg transition-colors flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
            >
              더보기
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          {/* Gallery Section */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-amber-100">
            <div className="flex items-center justify-between mb-6">
              <h3 
                className="text-2xl font-bold text-gray-900"
                style={{ fontFamily: "'Noto Serif KR', serif" }}
              >
                갤러리 미리보기
              </h3>
              <i className="ri-image-line text-2xl text-amber-600"></i>
            </div>
            
            <div className="space-y-4">
              {gallery.map((item, index) => (
                <a
                  key={index}
                  href="#"
                  className="block group cursor-pointer"
                >
                  <div className="relative rounded-lg overflow-hidden mb-2">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-32 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                    <div className="absolute bottom-2 left-2 right-2">
                      <span className="text-white text-xs font-semibold bg-black/50 px-2 py-1 rounded">
                        {item.count}
                      </span>
                    </div>
                  </div>
                  <h4 className="font-semibold text-gray-900 group-hover:text-amber-700 transition-colors">
                    {item.title}
                  </h4>
                </a>
              ))}
            </div>

            <a
              href="#"
              className="mt-6 w-full py-3 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg transition-colors flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
            >
              더보기
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
